(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function resolveEndMs(root) {
    var dur = root.getAttribute('data-duration-seconds');
    if (dur != null && dur !== '') {
      var secs = parseInt(dur, 10);
      if (!Number.isNaN(secs) && secs > 0) {
        return Date.now() + secs * 1000;
      }
    }
    var raw = root.getAttribute('data-end');
    if (!raw) return NaN;
    return Date.parse(raw);
  }

  function tick(root, endMs) {
    if (Number.isNaN(endMs)) return;

    var now = Date.now();
    var diff = Math.max(0, endMs - now);

    var hrs = Math.floor(diff / 3600000);
    diff -= hrs * 3600000;
    var min = Math.floor(diff / 60000);
    diff -= min * 60000;
    var sec = Math.floor(diff / 1000);

    var hEl = root.querySelector('[data-unit="hours"]');
    var mEl = root.querySelector('[data-unit="minutes"]');
    var sEl = root.querySelector('[data-unit="seconds"]');
    if (hEl) hEl.textContent = pad(hrs);
    if (mEl) mEl.textContent = pad(min);
    if (sEl) sEl.textContent = pad(sec);
  }

  function init(root) {
    var endMs = resolveEndMs(root);
    function run() {
      tick(root, endMs);
    }
    run();
    setInterval(run, 1000);
  }

  document.querySelectorAll('[data-landing-countdown-root]').forEach(init);
})();
